import Vue from 'vue'
import Main from './main.vue'
import { LEAVE_ROLE, TAB_ROLE_ID, TOP_ROLE_ID } from '@/utils/constUtils'
import { getItem } from '@/utils/comUtils'

const MConstructor = Vue.extend(Main) // 直接将Vue组件作为Vue.extend的参数
let MInstance = null
/**
 * 登录窗口
 * @param {object} options 配置
 */
const MAddress = async options => {
  return new Promise(async (resolve, reject) => {
    if (typeof options !== 'object') {
      reject(new Error('参数错误'))
      return
    }
    let _options = {
      role: options.role || LEAVE_ROLE.classTeacher, // 100 老师组
      corpName: options.corpName || '', // 钉钉机构名
      corpId: options.corpId || '', // 钉钉机构Id
      campus: options.campus || {}, // 初始校区列表(角色为管理员时有效)
      selectedMap: options.selectedMap || {}, // 已选择的值，用于回显
      title: options.title // 要展示的弹框的title
    }

    // 老师角色取优先级
    await setTopRole(_options)

    // eslint-disable-next-line
    _options.close = function (result) {
      MAddress.close()
        .then(() => {
          resolve(result)
        })
        .catch(err => {
          reject(err)
        })
    }
    // eslint-disable-next-line
    _options.closeOnly = function () {
      MAddress.close()
        .then(res => {
          resolve({
            $type: this.needReturn ? 'onlyReturn' : ''
          })
        })
        .catch(err => {
          reject(err)
        })
    }
    MInstance = new MConstructor({
      data: _options
    })
    MInstance.vm = MInstance.$mount() // 挂载但是并未插入dom，是一个完整的Vue实例
    MInstance.dom = MInstance.vm.$el
    document.body.appendChild(MInstance.dom) // 将dom插入body
    MInstance.vm.visible = true
  })
}

// eslint-disable-next-line
MAddress.close = function () {
  return new Promise((resolve, reject) => {
    if (MInstance) {
      // 销毁vm实例与DOM之间的关联
      MInstance.vm.$destroy()
      window.history.go(-1)
      // 防止返回后通讯录一直盖在界面上没有消失
      let $addressDom = MInstance.dom
      $addressDom && $addressDom.remove()
      MInstance = null
    } else {
      let $addressDom = document.getElementById('$address-book$')
      $addressDom && $addressDom.remove()
    }
    resolve()
  })
}

// 老师角色处理
const setTopRole = async _options => {
  if (_options.role !== LEAVE_ROLE.classTeacher) return

  let { role } = getItem(TAB_ROLE_ID) || {}
  if (!role) {
    let _topRole = getItem(TOP_ROLE_ID)
    let _roleIdList = getItem('roleIdList')
    role = _topRole || (_roleIdList && _roleIdList[0])
  }
  _options.role = role
}
export default MAddress
